
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartFullLightLines as ObiChartFullLightLinesElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-full-light-lines.js';
 
 
 

 
 export const ObiChartFullLightLines = createComponent({
   react: React,
   tagName: 'obi-chart-full-light-lines',
   elementClass: ObiChartFullLightLinesElement,
   events: {
     
   }
  });
 
 